/* Subskrypcja — „Twój plan" as rows, and the line of room above „Zmień plan". The groups, rows and
 * button paints are `AccountScreen.module.css`'s; this file draws only what the rows hold.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

.failure {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
}

/* A row's value, in body ink. The row's label column is the name; this is the answer. */
.value {
  display: block;
  font-size: var(--fs-button-sm);
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.note {
  display: block;
  margin-top: var(--space-1px);
  font-size: var(--fs-micro);
}

/* The wait, standing in a row's own box: one line of value. */
.valueBar {
  display: block;
  width: 40%;
  height: var(--fs-button-sm);
}

/* The figure and its caption, on one baseline. */
.figureLine {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  color: var(--text-2);
}

.figure {
  font-size: var(--fs-h3);
  font-weight: var(--fw-bold);
  line-height: var(--lh-none);
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

/* A capped plan's seats. Neutral ink: the accent is the primary's, and a seat taken is a fact
 * rather than an action. Pending seats are hatched, so the two never differ in colour alone. */
.bar {
  display: flex;
  gap: var(--space-3px);
  margin-top: var(--space-2);
}

.seat {
  flex: 1;
  height: var(--h-account-seat);
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-bar);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin-top: var(--space-2);
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

.legendEntry {
  display: inline-flex;
  gap: var(--space-1-5px);
  align-items: center;
}

.legendMark {
  width: var(--sz-account-legend-mark);
  height: var(--sz-account-legend-mark);
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-hair);
}

.seatActive {
  background: var(--text-2);
  border-color: transparent;
}

.seatPending {
  background: var(--hatch-pending);
  border-color: var(--border-2);
}

/* One line of room between the plan and the catalogue — see the component. Its height IS the gap
 * between the two sections, so the empty room costs the layout nothing it did not already have. */
.noticeLine {
  display: flex;
  align-items: center;
  min-height: var(--h-account-notice-line);
}

/* Warn ink and words, never a tinted band: what the line says is the state. */
.notice {
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--warn-ink);
}

.noticeRetry {
  margin-left: var(--space-2);
  text-decoration: underline;

  --inline-text-ink: var(--warn-ink);
}

.mail {
  font-size: var(--fs-note);
  color: var(--text);
  text-decoration: underline;
  text-underline-offset: var(--space-2px);
}

.mail:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}
